module.exports = __webpack_public_path__ + "static/media/branded-order-web-view.bd4d3c90.png";